import { SET_SERVERS, SET_ENABLED_SERVERS } from './constants'

export function setServers(servers) {
    return {
        type: SET_SERVERS,
        payload: servers,
    }
}

export function setEnabledServers(enabledServerIds) {
    return {
        type: SET_ENABLED_SERVERS,
        payload: enabledServerIds,
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/servers/actions.js